module.exports = __webpack_public_path__ + "img/lightgreen-pin.44098796.png";